module.exports = __webpack_public_path__ + "static/logo-cinza-f81784878b56fc6f17120efa064948fe.svg";